/* eslint-disable eqeqeq */
import api from '../../services/service'
const header = {
  headers: {
    'Access-Token': sessionStorage.token
    // 'Access-Token': 'aca9457564ee48728a61c3d67d06e3e1'
  }
}
const residences = [
  {
    value: 'zhejiang',
    label: 'Zhejiang',
    children: [
      {
        value: 'hangzhou',
        label: 'Hangzhou',
        children: [
          {
            value: 'xihu',
            label: 'West Lake'
          }
        ]
      }
    ]
  },
  {
    value: 'jiangsu',
    label: 'Jiangsu',
    children: [
      {
        value: 'nanjing',
        label: 'Nanjing',
        children: [
          {
            value: 'zhonghuamen',
            label: 'Zhong Hua Men'
          }
        ]
      }
    ]
  }
]
export default {
  data () {
    return {
      previewVisible: false,
      previewImage: '',
      filePic: '',
      fileList: [
        // {
        //   uid: '-1',
        //   name: 'xxx.png',
        //   status: 'done',
        //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
        // }
      ],
      confirmDirty: false,
      residences,
      autoCompleteResult: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0
          },
          sm: {
            span: 16,
            offset: 8
          }
        }
      },
      roleList: [],
      user_data: null
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'register' })
  },
  methods: {
    testdata () {
      console.log(this.password)
    },
    handleCancel () {
      this.previewVisible = false
    },
    handlePreview (file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    handleChange ({ fileList }) {
      this.fileList = fileList
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          values.role_id = parseInt(values.role_id)
          if (this.user_data != null) {
            values.user_code = this.user_data.user_code
            values.url_image = this.filePic
            values.company_id = 1
            values.branch_id = 1
            values.active_status = 1
            this.userUpdate(values)
          } else {
            this.confirmData(values)
          }
        }
      })
    },
    handleConfirmBlur (e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword (rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('รหัสผ่านไม่ตรงกัน')
      } else {
        callback()
      }
    },
    validateToNextPassword (rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true })
      }
      callback()
    },
    handleWebsiteChange (value) {
      let autoCompleteResult
      if (!value) {
        autoCompleteResult = []
      } else {
        autoCompleteResult = ['.com', '.org', '.net'].map(domain => `${value}${domain}`)
      }
      this.autoCompleteResult = autoCompleteResult
    },
    confirmData (val) {
      this.$store.commit('Loading')
      console.log(val)
      api.addUser(this.REST_URL,
        header,
        val,
        result => {
          console.log(result)
          if (result.response === 'success') {
            this.$notification['success']({
              message: 'เพิ่มข้อมูลผู้ใช้งานสำเร็จ',
              description:
                      result.message
            })
            this.$router.push('manageusers')
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    userUpdate (val) {
      this.$store.commit('Loading')
      console.log(JSON.stringify(val))
      api.userUpdate(this.REST_URL,
        header,
        val,
        result => {
          console.log(result)
          if (result.response === 'success') {
            this.$notification['success']({
              message: 'แก้ไขข้อมูลผู้ใช้งานสำเร็จ',
              description: result.message
            })
            this.$router.push('/manageusers')
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getRole () {
      api.getRole(this.REST_URL,
        {},
        {},
        result => {
          // console.log(result)
          if (result.response === 'success') {
            this.roleList = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description:
                result.message
            })
          }
          // this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getUserDetail (val) {
      console.log(val)
      api.userDetail(this.REST_URL,
        header,
        {
          'user_code': this.user_code
          // 'user_code': 'UID63011600001'
        },
        result => {
          // console.log(result)
          if (result.response === 'success') {
            this.user_data = result.data
            this.filePic = result.data.url_image
            this.$nextTick(() => {
              this.form.setFieldsValue(result.data, ['name', 'register'])
            })
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description:
                result.message
            })
          }
          // this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    uploadImgDefault () {
      var imagefile = document.querySelector('#imgDefault')
      if (imagefile.files.length > 0) {
        let formData = new FormData()
        formData.append('myFile', imagefile.files[0])
        formData.append('type', 'product')
        api.uploadImage(
          this.REST_URL,
          header,
          formData,
          result => {
            if (result.response === 'success') {
              this.filePic = result.data.url
            } else {
              alert(result.message)
            }
          },
          error => {
            alert(JSON.stringify(error))
          }
        )
      }
    }
  },
  mounted () {
    this.user_code = this.$route.params.user_code
    console.log(this.user_code)
    this.getRole()
    if (this.user_code != '') {
      this.getUserDetail()
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/manage_user.js